<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-40 o-dialog--lg-40 o-dialog--xl-40 o-dialog-h--55"
    title="添加评估成员"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <section>
      <el-form
        ref="form"
        class="c-form"
        :model="form"
        :rules="rules"
        :inline="true"
        label-position="right"
        label-width="100px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="姓名"
              prop="userCodes"
            >
              <el-checkbox-group
                v-model="form.userCodes"
                class="c-form__checkbox-group"
              >
                <el-checkbox
                  v-for="item in userList"
                  :key="item.capacityCode"
                  class="o-check"
                  :label="item.capacityCode"
                >
                  {{ item.capacityName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'JxxfPgMemberDialog',
  props: {
    members: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialogShow: true,
      loading: false,
      userList: [],
      form: {
        userCodes: []
      },
      rules: {
        userCodes: [this.$validUtils.required('姓名')]
      }
    };
  },
  methods: {
    loadUsers () {
      const currentUser = this.$HMStoreService.getUserinfo();
      const params = {
        deptCode: currentUser ? currentUser.dept.deptCode : this.deptCode
      };
      this.loading = true;
      this.$axios.get(`${this.$config.commontCtx}/roleCapacity/role/JX-PG/capacities`, { params })
        .then(response => {
          this.userList = response.data || [];
        })
        .catch(error => {
          console.error('获取评估人员信息失败', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeDialog () {
      this.$emit('close');
    },
    handleSave () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const selected = new Set(this.form.userCodes);
        const retained = this.members.filter(item => selected.has(item.ryDm));
        const retainedCodes = new Set(retained.map(item => item.ryDm));
        const added = this.form.userCodes
          .filter(code => !retainedCodes.has(code))
          .map(code => {
            const user = this.userList.find(item => item.capacityCode === code) || {};
            return {
              ryDm: code,
              ryMc: user.capacityName,
              ryjs: 'PGCY',
              pglxDm: '',
              zc: '',
              zgzsh: ''
            };
          });
        this.$emit('save', retained.concat(added));
      });
    }
  },
  created () {
    this.form.userCodes = Array.from(new Set(this.members.map(item => item.ryDm)));
    this.loadUsers();
  }
};
</script>

<style scoped>
.o-check {
  padding: 10px;
}
</style>
